// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"193":"52bc1bd64d37d46a","750":"914cef43c974beba"}[chunkId] + ".js";
};